import { ChatMessage, RoomStageInfo, TextMessage } from '../types';

export function messageTransition(
  setMessages: React.Dispatch<React.SetStateAction<ChatMessage[]>>,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  newMessage: ChatMessage,
  setStages: React.Dispatch<React.SetStateAction<RoomStageInfo[]>>,
) {
  if (newMessage.type === 'completed_stage') {
    setStages((stages) => {
      const completedStage = stages.find((stage) => stage.name === newMessage.name);
      if (!completedStage) {
        console.warn(`Could not find stage ${newMessage.name}`);
        return stages;
      }
      // TODO if completedStage is the last stage, then set the room to done
      const newStages = stages.map((stage) => {
        if (stage.stageUuid === completedStage.stageUuid) {
          return {
            ...stage,
            // TODO check if this uses UTC time
            completedAt: new Date(),
          };
        } else if (
          completedStage.nextStageUuid &&
          stage.stageUuid === completedStage.nextStageUuid
        ) {
          return {
            ...stage,
            // TODO check if this uses UTC time
            startedAt: new Date(),
          };
        }
        return stage;
      });
      return newStages;
    });
  }
  if (newMessage.type === 'solved_puzzle') {
    setStages((stages) => {
      const newStages = stages.map((stage) => {
        const newPuzzles = stage.puzzles.map((puzzle) => {
          if (puzzle.name === newMessage.name) {
            return {
              ...puzzle,
              // TODO check if this uses UTC time
              completedAt: new Date(),
            };
          }
          return puzzle;
        });
        return {
          ...stage,
          puzzles: newPuzzles,
        };
      });
      return newStages;
    });
  }
  setMessages((messages) => {
    const newMessages: ChatMessage[] = [];
    let found = false;
    // go through each message.
    //  never need to mess with a message with a uuid, as that's finalized
    //
    for (const message of messages) {
      if (message.uuid) {
        newMessages.push(message);
        // if old message has no uuid and new message is user, then replace with finalized message
      } else if (
        !found &&
        newMessage.author_type === 'user' &&
        newMessage.type === 'text' &&
        message.author_type === 'user' &&
        message.type === 'text'
      ) {
        newMessages.push(newMessage);
        found = true;
      } else if (
        !found &&
        newMessage.author_type === 'user' &&
        newMessage.type === 'text' &&
        message.author_type === 'user' &&
        message.type === 'audio'
      ) {
        newMessages.push(newMessage);
        found = true;
      } else if (
        !found &&
        newMessage.author_type === 'user' &&
        newMessage.type === 'audio' &&
        message.author_type === 'system' &&
        message.type === 'loading'
      ) {
        newMessages.push(newMessage);
        newMessages.push(message);
        found = true;
      } else if (
        !found &&
        newMessage.author_type === 'system' &&
        newMessage.type === 'loading' &&
        message.author_type === 'system' &&
        message.type === 'loading'
      ) {
        // skip multiple loading messages
        continue;
      } else if (
        !found &&
        newMessage.author_type === 'user' &&
        newMessage.type === 'audio' &&
        message.author_type === 'user' &&
        message.type === 'audio'
      ) {
        // skip multiple of the same audio messages
        continue;
      } else if (
        !found &&
        newMessage.author_type === 'system' &&
        newMessage.type === 'text' &&
        message.author_type === 'system' &&
        message.type === 'text'
      ) {
        newMessages.push(newMessage);
        found = true;
      } else {
        newMessages.push(message);
      }
    }

    // if we never found a place to put the new user message, then add it to the end
    if (!found && newMessage.author_type === 'user') {
      newMessages.push(newMessage);
    } else if (!found && newMessage.author_type === 'system' && newMessage.type === 'text') {
      if (newMessages.length > 0) {
        const lastMessage = newMessages[newMessages.length - 1];
        if (lastMessage.type === 'loading') {
          newMessages.pop();
        }
      }
      newMessages.push(newMessage);
    } else if (newMessage.type === 'done') {
      setLoading(false);
    } else if (newMessage.type === 'loading') {
      newMessages.push(newMessage);
      setLoading(true);
    } else if (newMessage.author_type === 'system') {
      if (newMessages.length === 0) {
        newMessages.push(newMessage);
      } else {
        const lastMessage = newMessages[newMessages.length - 1];
        // if the last message is a loading message, then replace it with the new message
        if (lastMessage.type === 'loading') {
          newMessages.pop();
          if (newMessage.type === 'text_delta') {
            const textMessage: TextMessage = {
              type: 'text',
              roomUuid: newMessage.roomUuid,
              content: newMessage.value,
              author_type: newMessage.author_type,
              user: newMessage.user,
              createdAt: newMessage.createdAt,
            };
            newMessages.push(textMessage);
          } else {
            newMessages.push(newMessage);
          }
        } else if (lastMessage.type === 'text_delta' && newMessage.type === 'text_delta') {
          // if the last message is a text_delta message and the new message is a text_delta message, then combine them
          const combinedMessage: TextMessage = {
            type: 'text',
            roomUuid: newMessage.roomUuid,
            content: lastMessage.value + newMessage.value,
            author_type: newMessage.author_type,
            user: newMessage.user,
            createdAt: lastMessage.createdAt,
          };
          newMessages.pop();
          newMessages.push(combinedMessage);
        } else if (lastMessage.type === 'text' && newMessage.type === 'text_delta') {
          // if the last message is a text message and the new message is a text_delta message, then combine them
          const combinedMessage: TextMessage = {
            type: 'text',
            roomUuid: newMessage.roomUuid,
            content: lastMessage.content + newMessage.value,
            author_type: newMessage.author_type,
            user: newMessage.user,
            createdAt: lastMessage.createdAt,
          };
          newMessages.pop();
          newMessages.push(combinedMessage);
        } else if (newMessage.type === 'text_delta') {
          const textMessage: TextMessage = {
            type: 'text',
            roomUuid: newMessage.roomUuid,
            content: newMessage.value,
            author_type: newMessage.author_type,
            user: newMessage.user,
            createdAt: newMessage.createdAt,
          };
          newMessages.push(textMessage);
        } else if (newMessage.type === 'text') {
          // skip multiple system text messages, really this check is just found = true for 'text' messages
          return newMessages;
        } else {
          newMessages.push(newMessage);
        }
      }
    }

    return newMessages;
  });
}
